export default "__VITE_ASSET__539de5c8__"